/**
 * DDD Domain - Published Language Contracts
 * 
 * This module exports the Published Language that DDD Domain
 * exposes to downstream bounded contexts. Following Eric Evans
 * Strategic DDD principles for proper context integration.
 * 
 * These contracts represent the stable API that DDD Domain
 * commits to maintaining for its customers/suppliers.
 */

// Query Criteria Contracts
export * from './DomainQueryCriteria';

// Summary Model Contracts  
export * from './DDDSummaryModels';

/**
 * Version of the DDD Published Language API
 * Increment when making breaking changes to contracts
 */
export const DDD_PUBLISHED_LANGUAGE_VERSION = '1.0.0';